<template>
	<section id="stat-clients"><br>
		<b-row class="mb-1">
			<b-col md="6">
				<b-form-group label="Périmètre" label-for="cuis-filter" class="mb-0">
					<b-form-select id="cuis-filter" v-model="cuis" :options="centerOptions" />
				</b-form-group>
			</b-col>
			<b-col md="6" class="d-flex align-items-end justify-content-end">
				<b-button variant="outline-primary" size="sm" @click="bumpKey">
					<feather-icon icon="RefreshCwIcon" /> Rafraîchir
				</b-button>
			</b-col>
		</b-row>
		<overview-cards :key="`ov-${cuis}-${reloadKey}`" :cuis="cuis" />
		<wp-plugin-stats :key="`wp-${cuis}-${reloadKey}`" :cuis="cuis" />
		<espace-client-stats :key="`ec-${cuis}-${reloadKey}`" :cuis="cuis" />
		<chatwoot-stats :key="`cw-${cuis}-${reloadKey}`" :cuis="cuis" />
	</section>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormSelect, BButton } from 'bootstrap-vue'
import OverviewCards from './OverviewCards.vue'
import WpPluginStats from './WpPluginStats.vue'
import EspaceClientStats from './EspaceClientStats.vue'
import ChatwootStats from './ChatwootStats.vue'

export default {
	components: {
		BRow,
		BCol,
		BFormGroup,
		BFormSelect,
		BButton,
		OverviewCards,
		WpPluginStats,
		EspaceClientStats,
		ChatwootStats,
	},
	data() {
		return {
			cuis: '',
			reloadKey: 0,
			centerOptions: [{ value: '', text: 'Tous les centres' }],
		}
	},
	created() {
		this.$http.get('/admin/lstsoc')
			.then(response => {
				const list = (response.data && response.data.ResultSoc) || []
				this.centerOptions = [{ value: '', text: 'Tous les centres' }].concat(
					list.map(s => ({ value: s.C_UI, text: s.C_libelle || s.C_rs || s.C_UI })),
				)
			})
			.catch(() => {})
	},
	methods: {
		bumpKey() { this.reloadKey += 1 },
	},
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
